import { useCallback } from 'react'

import { Button } from '@circlefin/components'
import { usePermission } from '@circlefin/permissions/react'
import { USER_MANAGEMENT_MUTATION } from '@services/permissions'
import { inviteUser } from '@services/sections/lib/settings'
import { useSegment, SegmentEvents } from '@services/segment'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import type { LinkButtonProps } from '@circlefin/components/lib/Button'
import type { LinkProps } from 'next/link'

export const InviteUserButton: React.FC<
  Omit<LinkButtonProps<LinkProps>, 'anchorComponent' | 'href' | 'onClick'>
> = (props) => {
  const { t } = useTranslation('settings')
  const { track } = useSegment()
  const [, { isAuthorized: isUserManagementAuthorized }] = usePermission(
    USER_MANAGEMENT_MUTATION,
  )

  const onClickTrack = useCallback(() => {
    track(SegmentEvents.InviteUserClicked)
  }, [track])

  // Renders for users with USER_MANAGEMENT_MUTATION
  if (!isUserManagementAuthorized) {
    return null
  }

  return (
    <div data-testid="invite-user-button">
      <Button.Link
        {...props}
        anchorComponent={Link}
        disabled={props.disabled ?? !isUserManagementAuthorized}
        href={inviteUser.route}
        onClick={onClickTrack}
      >
        {t('manageUsers.invite')}
      </Button.Link>
    </div>
  )
}
